export function getKeyFromVOrder(vOrder) {
  const {orderType, orderName} = vOrder;
  return `${orderType}--${orderName}`;
}
